import { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import AbstractStayStrategyModel from 'uplisting-frontend/models/abstract-stay-strategy';

export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export default class BaseRateModel extends AbstractStayStrategyModel {
  @attr('number') weekly!: number;
  @attr('boolean') extraCharges!: boolean;
  @attr('number') extraGuestCharge!: number;
  @attr('number') extraChargeAfter!: number;
  @attr('number') maximumOccupancy!: number;

  @belongsTo('property', {
    inverse: 'baseRate',
    async: false,
  })
  property!: ModelRegistry['property'];

  @cached
  get lowestRate(): number {
    return Math.min(...WEEKDAYS.map((day) => this[day]));
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'base-rate': BaseRateModel;
  }
}
